import dayjs from 'dayjs';

const CN = {
  header: {
    Home: '首页',
    News: '企业资讯',
    Manufacture: '模具制造',
    Product: '产品展示',
    Mall: '模具商城',
    Platform: '接单平台',
    Contact: '商务合作',
    Wechat: '公众号',
    TechnicalStrength: '技术实力',
    CustomerCase: '客户案例',
    moldCloud: '中模云网'
  },
  section: {
    introduce: {
      // companyName:'浙江中模精机有限公司',
      companyName:'宁波大榭开发区天正模具有限公司',
      title: '公司简介',
      more:'了解更多',
      content: '宁波大榭开发区天正模具有限公司，位于中国浙江省宁波市国家级大榭经济开发区， 创立于2000年。公司自创建以来，专于技术，坚于品质，多年来，始终专注于压铸模具的设计与制造。 公司设计开发制作的模具主要面向国内外大型知名厂商，涉及汽车零部件、医疗器械、照明系统、通讯产品等多个领域， 产品远销全国、日本、北美和欧洲。 '
    },
    products:{
      title:'产品展示',
      subtitle:'COMPANY PRODUCTS',
      more: '查看详情'
    },
    // honor: '企业荣誉',
    honor: {
      title:'企业荣誉',
      more: '了解更多',
      articleTitle:'国家级专精特新“小巨人”企业',
      content:'品质立业，善铸精诚，宁波天正模具有限公司在不断的创新与坚守中，定义精益标杆，在不断的开展与蜕变中，铸就民族品牌坚强脊梁。 | 作为国家级专精特新“小巨人”企业的天正模具，是国内大型镁合金结构件压铸模具的领军企业，掌握着大型镁合金模具的设计、制造及铸件生产工艺的核心技术，具备模具全生命周期的管理服务能力。'
    },
    tags:{
      win:'合作共赢',
      benefitingAll:'惠及天下',
      honesty:'诚实守信',
      brandValue:'品牌价值'
    },
    qrTips:'扫码关注公众号',
    partner: {
      title: '主要客户',
      firstRow: '丰田 | 通用 | 海拉',
      secondRow: '众泰 | 本田 | 福特',
      thirdRow: '标致 | 爱信 | 水星',
      fourRow: '保时捷 | 比亚迪 | 飞利浦',
      fifthRow: '上汽 | 日本电产',
    },
    culture: '企业文化',
    newsBlock: {
      more: '查看更多',
      title: '企业资讯'
    },
    poster: {
      title: '国·内'
    },
    CustomerCase: {
      title: '客户案例',
      more: '了解更多'
    }
  },
  footer: {
    blockTitles:{
      about:'关于天正',
      // moldManufacturing:'模具制造',
      // friendlyLinks:'友情链接',
      // contactInformation:'联系方式'
      // about:'中模精机',
      moldManufacturing:'模具制造',
      friendlyLinks:'友情链接',
      contactInformation:'联系方式'
    },
    technology:'技术研发',
    quality:'质量保证',
    deviceSupport:'设备支持',
    home: '首页',
    contact: '商务合作',
    molds: '模具商城',
    order: '接单平台',
    mail: '公司邮箱',
    business: '公司业务',
    license: '营业执照',
    wx: '官方微信',
    phone: '电话: ',
    fax: '传真: ',
    mailbox: '邮箱: ',
    website: '网站: http://www.tzmc.com',
    record: '备案号 ',
    copyright: `©${dayjs().year()} 天正模具有限公司 版权所有`,
    news: '企业资讯',
    product: '产品展示',
    customerCase: '客户案例',
    power: '技术实力',
    moldCloud: '中模云网'
  },
  manufacture: {
    title: '模具制造',
    subtitle: '技术研发 | 质量保证 | 设备支持 | 系统支持',
    crumbs: '您现在的位置',
    technology: '公司汇聚了国内外顶尖压铸工艺和模具制造研发技术人员，人才梯队坚实稳定，团结高效。公司先后设立了多个设计研发中心，保证从模具的开发设计到模具的生产输出，全流程科学有效的制造服务。现有包括海外工程师在内的开发设计、工程技术人员30余人，人才梯队坚实稳定，团结高效，为模具的设计及用户使用维护提供了可靠保证。',
    quality: '以质量求生存，以效率求发展，天正模具配备了一整套国际一流的精密模具加工设备，进口的微米级高速加工中心，可以满足客户对模具最苛刻的精度要求，高精度激光扫描三坐标测量仪，对模具进行全面检测，确保天正出品的每一套模具达到精工品质。',
    equipment: '多年的模具生产经验，公司已梳理、完善了一套符合“TZMC” 特色模具制造和管理需求的工作流程，使每一套模具制造都具有最佳的工艺路线和作业指导书。天正模具配备了一整套国际一流的精密模具加工设备，进口的微米级高速加工中心，可以满足客户对模具最苛刻的精度要求。',
    system: '天正模具引入E-MAN生产管理系统和APS排产系统，实现生产管理信息化、精细化、流程化，缩短模具生产周期，增强成本管理能力。',
    team: {
      title: '品质保障研发团队',
      content: '公司汇聚了国内外顶尖压铸工艺和模具制造研发技术人员，人才梯队坚实稳定，团结高效。公司先后设立了多个设计研发中心，保证从模具的开发设计到模具的生产输出，全流程科学有效的制造服务。现有包括海外工程师在内的开发设计、工程技术人员40余人，人才梯队坚实稳定，团结高效，为模具的设计及用户使用维护提供了可靠保证。',
      technicalPersonnel: '技术人员',
      undergraduateDegree: '本科学历',
      developmentCenter: '设计研发中心',
      GenuineDesignSoftware: '正版设计软件'
    },
    patent: {
      companyName: '天·正·模·具',
      slogan: '品质筑基，专利引领，荣誉见证',
      subSlogan: 'Quality Lays the Foundation, Patents Lead the Way, Honors Bear Witness'
    },
    equipments: {
      title: '高精设备铸就高质量产品',
      content: '天正模具以质量和效率为核心，配备了国际一流的精密模具加工设备和进口的微米级高速加工中心，能够满足客户对模具的高精度要求。同时，公司还引入了高精度激光扫描三坐标测量仪进行全面检测，确保每一套模具都达到精工品质。多年的生产经验使公司形成了一套符合自身特色的工作流程，为模具制造提供了最佳的工艺路线和作业指导书。',
      MeasuringInstrument: '高精度激光扫描三坐标测量仪',
      MachiningCenter: '进口微米级高速加工中心'
    },
    systems: {
      title: '天正模具引入E-MAN生产管理系统和APS排产系统',
      ProductionManagement: {
        title: '生产管理',
        desc: '信息化集成与可视化展示，实现生产管理信息化、精细化、流程化。'
      },

      ProductionCycle: {
        title: '生产周期',
        desc: '优化生产计划，实时监控生产进度，缩短模具生产周期。'
      },

      ManagementCosts: {
        title: '管理成本',
        desc: '通过优化生产流程减少损耗、合理安排生产批次降低固定成本。'
      }
    }
  },
  contact: {
    title: '业务联系',
    business: {
      title: '业务联系',
      domestic: '国内',
      international: '国际'
    },
    technology: {
      title: '技术联系',
      Daxie: '大榭技术部',
      Beilun: '北仑技术部'
    },
    location: '浙江省宁波市大榭开发区北渡路5号',
    tab: {
      business: '商务合作',
      job: '人才招聘'
    },
    job: {
      title: '招聘岗位',
      SocialRecruitment: '社会招聘',
      CampusRecruitment: '校园招聘',
      search: '请输入职位',
      Duty: '岗位职责',
      JobRequirements: '任职要求',
      TreatmentAndWelfare: '待遇福利',
      numberRecruitsUnit: '人',
      resume: '投递简历',
      uploadResume: '上传简历',
      cancel: '取消上传',
      confirm: '立即上传',
      uploadFail: '上传失败',
      uploadSuccess: '上传成功',
      emptyDesc: '暂无职位...'
    },
    contact: {
      phone: '电话',
      fax: '传真',
      email: '邮箱',
      address: '地址'
    }
  },
  content:{
    News: '新闻中心',
    Company: '公司新闻',
    Industry: '行业资讯',
    More: '更多',
    NewsCenter: '新闻中心',
    Location: '您现在的位置',
    All: '全部',
    Productdisplay: '产品展示',
    Molds: '模具展示',
    Products: '产品展示',
    Mold: '模具',
    Schimmel: '模具',
    Parts: '汽车零配件',
    Machinery: '通用机械',
    Other: '其他',
    TechnicalStrength: '技术实力'
  },
  news: {
    createTime: '本文创建时间：'
  },
  companyDesc: {
    FoundingDate: '成立时间',
    Employees: '公司员工',
    Customer: '战略合作伙伴',
    FoundingDateUnit: '年'
  },
  notFound: {
    message: '您所访问的页面不存在！！！',
    tips: '请检查您输入的网址是否正确，或点击下面的按钮返回主页。',
    backHome: '返回主页'
  },
  customerService: '在线客服'

}


export default CN